import { Inline } from '@etg/wings';
import { css } from '@eti/styles';
import type { EventSegmentType } from '@eti/schema-types';
import { useTranslation } from '@eti/providers';
import TripEventBadge from '../../../../../../widgets/trip-event/TripEventBadge';
import { EVENT_SEGMENT_TYPE_TO_TITLE_KEY } from '../../../../../../widgets/trip-event/constants';
import { screenReadersOnlyStyles } from '../../../../../../utils/styleUtils';

const inlineStyles = css`
  gap: 8px 4px;
`;

interface TripIconsProps {
  boundIndex: number;
  eventTypes: Exclude<EventSegmentType, typeof EventSegmentType.Stop>[];
}
const TripIcons = ({ boundIndex, eventTypes }: TripIconsProps) => {
  const { t } = useTranslation();
  const allEventTypesText = eventTypes
    .map((type) => t(EVENT_SEGMENT_TYPE_TO_TITLE_KEY[type]))
    .join(', ');

  return (
    <>
      <span className={screenReadersOnlyStyles} id={`bound-${boundIndex}-trip-events`}>
        {t('ScreenReader.ItineraryButton.TripEvents.Text', allEventTypesText)}
      </span>
      <Inline align="center" as="ul" className={inlineStyles}>
        {eventTypes.map((type) => (
          <TripEventBadge hasTitle key={type} type={type} />
        ))}
      </Inline>
    </>
  );
};

export default TripIcons;
